<app-layout>
  <app-voltar route="listagem/laudos-higienizacao" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form" (ngModelChange)="clearForms()">
      <div class="formList">
        <app-input
          type="text"
          label="Placa do Cavalo"
          name="TX_PLCA_CAVA"
          formControlName="TX_PLCA_CAVA"
          placeholder="Digite aqui"
          mask="AAA-0A00"
          [requiredInput]="true"
          (blurEvent)="setForms()"
          [disabled]="disabledLaudo"
        ></app-input>
        <app-input
          style="display: none"
          type="number"
          label="Quilometragem"
          name="QT_KM"
          formControlName="QT_KM"
          placeholder="Digite aqui"
          [requiredInput]="false"
          [disabled]="this.statusInput"
        ></app-input>
        <app-input
          style="display: none"
          type="number"
          label="N° do Agendamento"
          name="PK_AGND"
          formControlName="PK_AGND"
          placeholder="Digite o número do agendamento"
          mask="0000000000"
          [disabled]="this.disabledLaudo"
          (blurEvent)="getServicoEntrada()"
        ></app-input>
        <app-input
          style="display: none"
          type="text"
          label="FIHL / Lava Jato N°"
          name="FK_SRVC_ENTR"
          formControlName="FK_SRVC_ENTR"
          placeholder="Digite o número do ticket de serviço de Higienização"
          [requiredInput]="false"
          [disabled]="this.statusInput"
          (blurEvent)="getServicoEntrada()"
        ></app-input>
        <app-input
          type="select"
          [requiredInput]="true"
          [disabled]="disabledLaudo || statusInput"
          label="Transportadora"
          name="FK_TPTD"
          formControlName="FK_TPTD"
          placeholder="Selecione"
          [selectData]="transportadorasOptions"
          (ngModelChange)="onTransportadoraSelecionada($event)"
        ></app-input>
        <app-input
          type="text"
          [disabled]="disabledLaudo || statusInput"
          label="CPF/CNPJ"
          name="TX_CPF_CNPJ_TRND"
          formControlName="TX_CPF_CNPJ_TRND"
          placeholder="---"
        ></app-input>
        <app-input
          type="text"
          [disabled]="disabledLaudo || statusInput"
          label="Telefone da Transportadora"
          name="NU_TELE_TRND"
          formControlName="NU_TELE_TRND"
          placeholder="---"
        ></app-input>
        <app-input
          type="disabled"
          [disabled]="true"
          label="Data e Horário do Serviço"
          name="DT_SRVC_ENTR"
          formControlName="DT_SRVC_ENTR"
          placeholder="Digite aqui"
        ></app-input>
        <app-input
          type="text"
          [disabled]="disabledLaudo || statusInput"
          label="Motorista"
          name="NM_MTRT"
          formControlName="NM_MTRT"
          placeholder="Digite aqui"
          [requiredInput]="true"
        ></app-input>
        <app-input
          style="display: none"
          type="text"
          label="RG"
          name="TX_RG"
          formControlName="TX_RG"
          placeholder="Apenas números e letras"
          [requiredInput]="false"
          maxLength="9"
          [disabled]="this.statusInput"
        ></app-input>
        <div class="cpf-field">
          <app-input
            type="text"
            [requiredInput]="true"
            [disabled]="disabledLaudo || statusInput"
            label="CPF"
            name="TX_CPF"
            formControlName="TX_CPF"
            placeholder="Digite aqui"
            mask="000.000.000-00"
          ></app-input>
          <span
            *ngIf="
              form.controls['TX_CPF'].hasError('cpfInvalido') &&
              (form.controls['TX_CPF'].dirty || form.controls['TX_CPF'].touched)
            "
            class="cpf-error-message"
          >
            CPF inválido.
          </span>
        </div>
        <app-input
          type="disabled"
          [disabled]="true"
          label="Reboque-1 (Carreta 1)"
          name="TX_CRRT_1"
          formControlName="TX_CRRT_1"
          placeholder="Digite aqui"
          mask="AAA-0000||AAA-0A00"
        ></app-input>
        <app-input
          type="disabled"
          [disabled]="true"
          label="Reboque-2 (Carreta 2)"
          name="TX_CRRT_2"
          formControlName="TX_CRRT_2"
          placeholder="Digite aqui"
          mask="AAA-0000||AAA-0A00"
        ></app-input>
        <app-input
          type="disabled"
          [disabled]="true"
          label="Reboque-3 (Carreta 3)"
          name="TX_CRRT_3"
          formControlName="TX_CRRT_3"
          placeholder="Digite aqui"
          mask="AAA-0000||AAA-0A00"
        ></app-input>
        <app-input
          type="disabled"
          [disabled]="true"
          label="Tipo da Carreta"
          name="TX_TIPO_CRRT"
          formControlName="TX_TIPO_CRRT"
          placeholder="Digite aqui"
        ></app-input>
        <app-input
          style="display: none"
          type="disabled"
          [disabled]="true"
          label="Tipo de Carga (Resíduo)"
          name="TX_TIPO_CRGA"
          formControlName="TX_TIPO_CRGA"
          placeholder="Digite aqui"
        ></app-input>
        <app-input
          type="text"
          label="Operador:"
          name="NM_OPER"
          formControlName="NM_OPER"
          placeholder="Digite aqui"
          [requiredInput]="true"
          [disabled]="disabledLaudo || statusInput"
        ></app-input>
        <app-input
          style="display: none"
          type="text"
          label="Observação:"
          name="TX_OBSV"
          formControlName="TX_OBSV"
          placeholder="Digite aqui"
          [disabled]="this.statusInput"
        ></app-input>
        <!-- <app-input
          type="text"
          label="Transportador:"
          name="TX_TRNP"
          formControlName="TX_TRNP"
          placeholder="Digite aqui"
          [disabled]="this.statusInput"
        ></app-input> -->
        <app-input
          type="select"
          label="Terminal:"
          name="TX_CRGM"
          formControlName="TX_CRGM"
          placeholder="Selecione o Terminal"
          [selectData]="terminalOptions"
          [disabled]="disabledLaudo || statusInput"
        ></app-input>
        <app-input
          style="display: none"
          type="datetime-local"
          label="HORA INÍCIO:"
          name="DT_INIT"
          formControlName="DT_INIT"
          placeholder="Digite aqui"
          [disabled]="disabledLaudo || statusInput"
        ></app-input>
        <app-input
          type="datetime-local"
          label="HORA TÉRMINO:"
          name="DT_TERM"
          formControlName="DT_TERM"
          placeholder="Digite aqui"
          [disabled]="disabledLaudo || statusInput"
        ></app-input>
      </div>

      <app-accordion [itens]="itensInspecao" [formArray]="formArrayInspecoes" />

      <!-- <button type="button" (click)="verificarDadosInspecao()">
        Verificar as perguntas das inspeções
      </button> -->

      <app-botao
        *ngIf="!disabledLaudo"
        type="cadastro"
        [text]="isEditing ? 'Editar Laudo' : 'Salvar Laudo'"
        class="botao-cadastro"
        (click)="postarDados()"
        [disabled]="!form.valid"
      ></app-botao>
    </form>
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
